import { Component as BaseComponent, h } from 'preact';
import { connect } from 'react-redux';
import { smoothScrollToElement } from '../../shared/scroll';
import { MediaQuery as MQ } from '../../shared/media-query';

class Component extends BaseComponent {
    shouldComponentUpdate(nextProps) {
        if (nextProps.page != this.props.page) {
            return true;
        }

        return false;
    }

    render({ pages }) {
        if (pages > 1) {
            return (
                <article-pagination>
                    {this.renderPrevLink()}
                    {this.renderPageLinks()}
                    {this.renderNextLink()}
                </article-pagination>
            );
        }

        return null;
    }

    renderPrevLink = () => {
        if (this.props.page != 1) {
            return (
                <a
                    href={`?page=${this.props.page - 1}`}
                    onClick={(e) => this.handleClick(e, this.props.page - 1)}
                    rel='prev'
                >
                    Previous
                </a>
            );
        }

        return (<a />);
    }

    renderNextLink = () => {
        if (this.props.page != this.props.pages && this.props.pages > 1) {
            return (
                <a
                    href={`?page=${this.props.page + 1}`}
                    onClick={(e) => this.handleClick(e, this.props.page + 1)}
                    rel='next'
                >
                    Next
                </a>
            );
        }

        return (<a />);
    }

    renderPageLinks = () => {
        let delta = MQ.isMobile() ? 2 : 3;
        let range = [];
        let pages = [];
        let l;

        range.push(1);

        for (let i = this.props.page - delta; i <= this.props.page + delta; i++) {
            if (i < this.props.pages && i > 1) {
                range.push(i);
            }
        }

        if (this.props.pages != 1) {
            range.push(this.props.pages);
        }

        for (let i of range) {
            if (l) {
                if (i - l === 2) {
                    pages.push(l + 1);
                } else if (i - l !== 1) {
                    pages.push('...');
                }
            }

            pages.push(i);

            l = i;
        }

        return pages.map(page => {
            if (page == '...') {
                return (
                    <a href='#' onClick={(e) => e.preventDefault()} className='active'>
                        {page}
                    </a>
                );
            }

            return (
                <a
                    href={`?page=${page}`}
                    onClick={(e) => this.handleClick(e, page)}
                    className={page == this.props.page ? 'active' : ''}
                >
                    {page}
                </a>
            );
        });
    }

    handleClick = (e, page) => {
        if (this.props.articles[page]) {
            e.preventDefault();
            smoothScrollToElement(document.querySelector(`pager[data-page="${page}"]`));
        }
    }
}

const mapStateToProps = (state) => ({
    articles: state.articles && state.articles.list,
    page: state.articles && state.articles.page,
    pages: state.articles && state.articles.pages,
});

export default connect(mapStateToProps)(Component);